import React from "react";

export default function StudentDetailProfileSection({
  viewingStudent,
  visitLogs,
  icons,
}) {
  const prayerLog = visitLogs
    .filter((log) => log.studentId === viewingStudent.id && log.type === "기도")
    .sort((a, b) => new Date(b.date) - new Date(a.date))[0];

  const defaultProfileImage = viewingStudent.isTeacher
    ? viewingStudent.gender === "여"
      ? icons.teacher_female
      : icons.teacher_male
    : viewingStudent.gender === "남"
      ? "/images/boy_animated_light.png"
      : "/images/girl_animated_light.png";

  return (
    <div className="flex flex-col items-center text-center mb-8">
      <div className="relative mb-4">
        <div className="w-28 h-28 rounded-[2.5rem] overflow-hidden shadow-lg border-4 border-white bg-white">
          {viewingStudent.photoUrl ? (
            <img
              src={viewingStudent.photoUrl}
              alt="Profile"
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-white p-2">
              <img
                src={defaultProfileImage}
                alt="Profile"
                className="w-full h-full object-contain"
              />
            </div>
          )}
        </div>
        {!viewingStudent.isTeacher && viewingStudent.faithState === "초신자" && (
          <div className="absolute -bottom-2 -right-2 bg-yellow-400 text-white text-xs font-bold px-3 py-1.5 rounded-full border-[3px] border-white shadow-sm animate-pulse">
            NEW
          </div>
        )}
      </div>

      <h2 className="text-3xl font-extrabold text-gray-900 mb-1">
        {viewingStudent.name}
      </h2>

      <div className="flex flex-col items-center gap-2">
        {viewingStudent.isTeacher ? (
          <p className="text-gray-500 font-medium text-lg">
            {viewingStudent.role || "교사"}{" "}
            {viewingStudent.charge && `• ${viewingStudent.charge}`}
          </p>
        ) : (
          <p className="text-gray-500 font-medium text-lg">
            {viewingStudent.grade} {viewingStudent.class && `• ${viewingStudent.class}`}
          </p>
        )}
        {prayerLog && (
          <div className="flex items-center gap-2 bg-white/60 backdrop-blur-md px-4 py-2 rounded-xl border border-white/50 shadow-sm mt-1 animate-fade-in-up">
            <img src={icons.prayer} width={20} alt="prayer" />
            <p className="text-sm font-bold text-gray-700">"{prayerLog.content}"</p>
          </div>
        )}
      </div>
    </div>
  );
}
